import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage, Messaging } from 'firebase/messaging'
import { ToastrService } from 'ngx-toastr'

@Injectable({ providedIn: 'root' })
export class FirebaseService {
  private messaging: Messaging
  constructor(private toastr: ToastrService) {
    const firebaseApp = initializeApp(environment.firebase)
    this.messaging = getMessaging(firebaseApp)
  }
  requestPermission(): Promise<string | null> {
    return Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        return getToken(this.messaging, {
          vapidKey: environment.firebase.vapidKey
        })
          .then(token => {
            console.log('FCM Token:', token)
            localStorage.setItem('fcmToken', token)
            // TODO: Send token to your backend
            return token
          })
          .catch(err => {
            console.error('Error getting token:', err)
            return null
          })
      } else {
        console.warn('Notification permission not granted.')
        return null
      }
    })
  }
  listenForMessages(): void {
    onMessage(this.messaging, payload => {
      // console.log('Message received: ', payload)
      this.showLocalNotification(payload.notification?.title, payload.notification?.body)
    })
  }
  private showLocalNotification(title = '', body = ''): void {
    if (Notification.permission === 'granted') {
      new Notification(title, {
        body,
        icon: '/assets/icons/icon-72x72.png'
      })
      // this.toastr.success(body, title)
      //   new Notification('Test', {
      //     body: 'Test notification body',
      //     icon: '/assets/icons/icon-72x72.png'
      //   })
    }
  }
}
